import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/comics';

export default function LatestUpdates() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-primary-600 text-xs font-semibold tracking-widest uppercase mb-2 block">实时更新</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新上架
            </h2>
          </div>
          <Link
            to="/category/action"
            className="text-foreground-500 text-sm hover:text-primary-600 transition-colors inline-flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {latestUpdates.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={comic.coverUrl}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <h3 className="text-white font-heading font-semibold text-sm mb-1 truncate">
                    {comic.title}
                  </h3>
                  <p className="text-white/60 text-xs">{comic.chapter}</p>
                </div>
              </div>
              <div className="flex items-center justify-between px-0.5">
                <span className="text-foreground-400 text-xs">{comic.author}</span>
                <span className="text-accent-500 text-xs">{comic.time}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}